/**
 * @generated SignedSource<<5fb99915bfb9897b9211d1e22567f35c>>
 * @relayHash 6f6967aec6513c95b7a571ab38e5ef42
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6f6967aec6513c95b7a571ab38e5ef42

import { ConcreteRequest } from 'relay-runtime';
export type QuestionType = "FREE_TEXT" | "NUMERIC" | "RATING" | "SELECTION" | "SLIDER";
export type SurveyLabScoreLevel = "CRITICAL" | "INFO" | "REVIEW" | "WARNING";
export type surveyLabQuestionnaireQuery$variables = {
  appointmentId: string;
};
export type surveyLabQuestionnaireQuery$data = {
  readonly surveyLabQuestionnaireSummaryByAppointmentId: {
    readonly questionAndAnswers: ReadonlyArray<{
      readonly comment: string | null;
      readonly description: string;
      readonly proposedAnswers: ReadonlyArray<{
        readonly label: string | null;
      }>;
      readonly question: string;
      readonly type: QuestionType;
      readonly userAnswer: {
        readonly freeText: string | null;
        readonly number: number | null;
        readonly openAnswers: ReadonlyArray<{
          readonly label: string;
          readonly open: string | null;
        }> | null;
        readonly scoreLevel: SurveyLabScoreLevel | null;
        readonly selectedAnswers: ReadonlyArray<{
          readonly label: string;
          readonly open: string | null;
        }>;
      } | null;
    }>;
    readonly suggestedMedications: ReadonlyArray<string>;
    readonly telemedicineClassifier: {
      readonly aiReasoning: string;
      readonly aiRecommendation: string;
    } | null;
  } | null;
};
export type surveyLabQuestionnaireQuery = {
  response: surveyLabQuestionnaireQuery$data;
  variables: surveyLabQuestionnaireQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appointmentId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v2 = [
  (v1/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "open",
    "storageKey": null
  }
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "appointmentId",
        "variableName": "appointmentId"
      }
    ],
    "concreteType": "SurveySummaryData",
    "kind": "LinkedField",
    "name": "surveyLabQuestionnaireSummaryByAppointmentId",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "suggestedMedications",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "QuestionAndAnswers",
        "kind": "LinkedField",
        "name": "questionAndAnswers",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "comment",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "question",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserAnswer",
            "kind": "LinkedField",
            "name": "userAnswer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "number",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "scoreLevel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "freeText",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SelectedAnswer",
                "kind": "LinkedField",
                "name": "openAnswers",
                "plural": true,
                "selections": (v2/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SelectedAnswer",
                "kind": "LinkedField",
                "name": "selectedAnswers",
                "plural": true,
                "selections": (v2/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProposedAnswer",
            "kind": "LinkedField",
            "name": "proposedAnswers",
            "plural": true,
            "selections": [
              (v1/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TelemedicineClassifier",
        "kind": "LinkedField",
        "name": "telemedicineClassifier",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "aiReasoning",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "aiRecommendation",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "surveyLabQuestionnaireQuery",
    "selections": (v3/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "surveyLabQuestionnaireQuery",
    "selections": (v3/*:: as any*/)
  },
  "params": {
    "id": "6f6967aec6513c95b7a571ab38e5ef42",
    "metadata": {},
    "name": "surveyLabQuestionnaireQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "23c047b9e54376ed6e183458f7b7d787";

export default node;
